import React from 'react';
import {Formik, Form, Field} from 'formik';
import {FaCheck} from 'react-icons/fa';
import {AnimatePresence, motion} from 'framer-motion';

import {ErrorMessage} from '../components/forms';
import {ButtonPrimary} from '../components/Button';

import {useContactForm} from '../features/contact';

const ContactForm = () => {
  const {onSubmit, initialValues, validationSchema, isSuccess} = useContactForm();

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({isSubmitting}) => (
        <Form className="" noValidate>
          <div className="md:flex gap-6">
            <label>
              First name:
              <Field name="firstname" className="mb-2 lg:mb-0" />
              <ErrorMessage name="firstname" />
            </label>
            <label>
              Surname:
              <Field name="lastname" />
              <ErrorMessage name="lastname" />
            </label>
          </div>
          <div className="md:flex pt-2 lg:pt-4 md:gap-6 ">
            <label>
              Email:
              <Field name="email" className="mb-2 lg:mb-0" type="email" />
              <ErrorMessage name="email" />
            </label>
            <label>
              Contact number:
              <Field name="phone" type="tel" />
              <ErrorMessage name="phone" />
            </label>
          </div>
          <div className="w-full pt-4">
            <label>
              Leave us a message
              <Field name="message" as="textarea" />
              <ErrorMessage name="message" />
            </label>
          </div>
          <div className="mt-7 flex justify-end">
            <ButtonPrimary type="submit" label="Send Message" size="large" isLoading={isSubmitting} />
          </div>
          <div className="mt-7">
            <AnimatePresence>
              {isSuccess && (
                <motion.div
                  initial={{height: 0, opacity: 0}}
                  animate={{height: '100%', opacity: 1}}
                  className="text-green-400 border-green-400 flex items-center border rounded px-4 pt-2 pb-1 font-semibold text-base">
                  <FaCheck className="mr-3 -mt-1" /> Great! We’ll be in touch with you very soon.
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ContactForm;
